module.exports = __webpack_public_path__ + "static/media/bsnl_logo.349df99b.webp";